<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>

<ag-grid-angular [gridOptions]="gridOptions" [rowData]="networks" [ngClass]="[theme]" style="width: 100%;height: 100%"></ag-grid-angular>

<ng-template #requestsModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ isAdmin ? 'Requests - ' : "My company's requests - " }} {{ requestsNetwork.countryName }}({{ requestsNetwork.mcc }})/{{
        requestsNetwork.providerName }}({{ requestsNetwork.mnc }})</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="min-height: 150px">
    <div [hidden]="!requestsLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <td>User</td>
          <td>Date</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!requests.length">
          <td colspan="2" style="text-align: center">No requests</td>
        </tr>
        <tr *ngFor="let v of requests">
          <td>{{ v.user.email }}</td>
          <td>{{ v.createdAt | date: 'medium' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
